export default __webpack_public_path__ + "static/img/vogue_scene_animated_0387.b9a6709.webp";